import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LocalProfileLayout from './LocalProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import TypeLocalService from '../../services/TypeLocalService';
import LocalService from '../../services/LocalService';

const ViewLocal = () => {
	const { id } = useParams();
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [selectedTypeLocal, setSelectedTypeLocal] = useState([]);

	const [local, setLocal] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState('');
	const [typeLocalOptions, setTypeLocalOptions] = useState([]);

	const STATUS_CHOICES = [
		{ value: 'non_utilisé', label: 'Non utilisé' },
		{ value: 'utilisé', label: 'Utilisé' }
	];

	useEffect(() => {
		Promise.all([
			LocalService.getLocal(id),
			TypeLocalService.getAllTypeLocals()
		]).then(([localData, TypelocalData]) => {
			setLocal(localData.data);

			// Set default selection for status
			if (localData && localData.data) {
				const localStatus = localData.data.status;
				setSelectedStatus(localStatus);

				const localType = localData.data.type;
				setSelectedTypeLocal(localType);
			}

			// Transform the local type data into a format that React-Select can understand
			if (TypelocalData) {
				// Adjusted this line
				const formattedTypelocalData = TypelocalData.map((local) => ({
					// Adjusted this line
					value: local.id,
					label: local.type
				}));
				setTypeLocalOptions(formattedTypelocalData);
			}
		});
	}, [id]);

	const TYPE_CHOICES = typeLocalOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const localData = new FormData();

				// Add all your form data to the FormData
				localData.append('nom', form.nom.value);
				localData.append('description', form.description.value);
				localData.append('status', form.status.value);
				localData.append('capacite', form.capacite.value);
				localData.append('equipements', form.equipements.value);
				localData.append('type', form.type.value);

				// Call the TypeLocalService to create the TypeLocal
				const response = await LocalService.updateLocal(id, localData);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations sur le local',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<LocalProfileLayout>
			{local && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									<Col xs={12} className="mb-3">
										{/* Nom et description  */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="nom">
														Nom <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="nom"
														type="text"
														placeholder="Saisir le nom du Local"
														id="nom"
														required
														isInvalid={!!feedbackMessages['nom']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																nom: e.target.value ? '' : 'Le nom est requis.'
															}));
														}}
														defaultValue={local.nom}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['nom']}
													</Form.Control.Feedback>
												</Col>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="description">
														Description <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="description"
														as="textarea"
														placeholder="Saisir la Description du Local"
														id="description"
														required
														isInvalid={!!feedbackMessages['description']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																description: e.target.value
																	? ''
																	: 'La Description est requis.'
															}));
														}}
														defaultValue={local.description}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['description']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Status */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="status">
												Statut <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="status"
												required
												value={selectedStatus}
												isInvalid={!!feedbackMessages['status']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedStatus(value);
													// Reset feedback messages for points fields when status changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le statut</option>
												{STATUS_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['status']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* capacite   */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="capacite">
														Capacite <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="capacite"
														type="number"
														placeholder="Saisir la capacite du Local"
														id="capacite"
														required
														isInvalid={!!feedbackMessages['capacite']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																capacite: e.target.value
																	? ''
																	: 'La capacite est requis.'
															}));
														}}
														defaultValue={local.capacite}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['capacite']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* equipement */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="equipements">Equipements</Form.Label>
											<Form.Control
												name="equipements"
												type="text"
												placeholder="Saisir l'equipements du Local"
												id="equipements"
												isInvalid={!!feedbackMessages['equipements']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														equipements: e.target.value ? '' : ''
													}));
												}}
												defaultValue={local.equipements}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['equipements']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Type */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="type">
												Type de Local <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="type"
												required
												value={selectedTypeLocal}
												isInvalid={!!feedbackMessages['type']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedTypeLocal(value);
													// Reset feedback messages for points fields when type changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le type de local</option>
												{TYPE_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['type']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</LocalProfileLayout>
	);
};

export default ViewLocal;
